import { StoreInner } from '@types';

export const userSelectors = {
	userInfo: (store: StoreInner) => store.user
};
